import { render, staticRenderFns } from "./PhoneSetup.vue?vue&type=template&id=bfb08ebe&"
import script from "./PhoneSetup.vue?vue&type=script&lang=js&"
export * from "./PhoneSetup.vue?vue&type=script&lang=js&"
import style0 from "./PhoneSetup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports